var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-wrapper"},[(_vm.loading)?_c('LmComponentLoading',{attrs:{"fixed":""}}):_vm._e(),_c('form',{staticClass:"position-relative",attrs:{"id":_vm.id,"novalidate":""},on:{"submit":function($event){$event.preventDefault();}}},[_vm._t("default",null,{"isOnEditMode":_vm.isOnEditMode})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }